export function Footer() {
  return (
    <footer className="bg-white text-gray-600 py-10 border-t border-gray-200">
      <div className="max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-[140px]">
        <div className="footer-main grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* NEXSENS Logo & Info */}
          <div className="footer-left">
            <img
              src="/images/Layer_1.png"
              alt="NEXSENS Technology"
              className="max-w-[100%]"
            />
          </div>

          {/* Buy Column */}
          <div className="footer-main-menu">
            <div className="footer-menu">
              <h4 className="text-[#4D4D4D] font-bold mb-3 text-xl">Buy</h4>
              <ul className="space-y-2">
                <li><a href="/page/sensors" className="text-base text-[#4D4D4D] hover:text-gray-900 transition">Sensors</a></li>
                <li><a href="/page/systems" className="text-base text-[#4D4D4D] hover:text-gray-900 transition">Systems</a></li>
              </ul>
            </div>

            {/* Learn Column */}
            <div className="footer-menu">
              <h4 className="text-[#4D4D4D] font-bold mb-3 text-xl">Learn</h4>
              <ul className="space-y-2">
                <li><a href="/help" className="text-base text-[#4D4D4D] hover:text-gray-900 transition">Help Center</a></li>
                <li><a href="/page/measurements-handbook" className="text-base text-[#4D4D4D] hover:text-gray-900 transition">Measurements Handbook</a></li>
              </ul>
            </div>

            {/* Policy Column */}
            <div className="footer-menu">
              <h4 className="text-[#4D4D4D] font-bold mb-3 text-xl">Policy</h4>
              <ul className="space-y-2">
                <li><a href="/terms" className="text-base text-[#4D4D4D] hover:text-gray-900 transition">Terms of Service</a></li>
                <li><a href="/page/privacy-policy" className="text-base text-[#4D4D4D] hover:text-gray-900 transition">Privacy Policy</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-200 pt-10">
          <div className="flex flex-col md:flex-row justify-start items-center text-base text-[#4D4D4D] gap-6 copyright">
            <p>© 2026 NexSens Technology, Inc.</p> <p className="partition">|</p> <p>Questions? Call <a href="#" className="text-[#358ECD] transition font-semibold">937.426.2703</a> or email <a href="mailto:info@nexsens.com" className="text-[#358ECD] transition font-semibold">info@nexsens.com</a></p>
          </div>
        </div>
      </div>
    </footer>
  )
}
